import { useMemo } from 'react';

import { useGlobalFiltersHook } from 'hooks/useGlobalFiltersHook';

import { useQueryGetProjectVersionsList } from 'api/queries/getProjectVersionsList.query';
import { useQueryHighLevelProgram } from 'api/queries/highLevelProgram.query';

import { FilterNames, getFiltersData } from 'components/common/GlobalFilterComponent/GlobalFilterComponent.utils';

export const useHighLevelProgramProvider = ({
    widgetId,
    contractId,
    projectId,
    latestVersionId,
    globalFilterData,
    localFilters,
    maxLevel,
}) => {
    const isInPinboard = Boolean(widgetId);
    const source = widgetId ? localFilters : { ...globalFilterData, maxLevel };

    const filters = useMemo(() => {
        return getFiltersData({
            [FilterNames.ACTIVITY_CODES]: source?.activityCodes
                ?.filter((item) => !item.value.isExclude)
                .map((i) => i.value.name),
            [FilterNames.ACTIVITY_CODES_EXCLUDE]: source?.activityCodes
                ?.filter((item) => item.value.isExclude)
                .map((i) => i.value.name),
            [FilterNames.FRAGNET_SEARCH]: source?.milestoneFragnet,
            [FilterNames.TAG_CARD_BOARD]: source?.tags
                ?.filter((item) => !item.value.isExclude)
                .map((i) => i.value.name),
            [FilterNames.TAG_CARD_BOARD_EXCLUDE]: source?.tags
                ?.filter((item) => item.value.isExclude)
                .map((i) => i.value.name),
            [FilterNames.WBS_SEARCH]: source?.wbs,
            [FilterNames.MIN_WBS_LEVEL]: [source?.maxLevel[0]],
            [FilterNames.MAX_WBS_LEVEL]: [source?.maxLevel[1]],
        });
    }, [source?.activityCodes, source?.milestoneFragnet, source?.tags, source?.wbs, source?.maxLevel]);

    const state = {
        project: {
            projectId,
            contractId,
            latestVersionId,
        },
        globalFilter: {
            progressMeasurement: source?.progressMeasurement,
            resource: source?.resource,
            resourceType: source?.resourceType,
            activityCodes: source?.activityCodes,
            milestoneFragnet: source?.milestoneFragnet,
            tags: source?.tags,
            wbs: source?.wbs,
        },
        local: {
            maxLevel: source?.maxLevel,
        },
    };

    const pillsData = {
        activityCodes: source?.activityCodes?.filter((item) => !item.value?.isExclude).map((i) => i.value?.name),
        activityCodesExclude: source?.activityCodes?.filter((item) => item.value?.isExclude).map((i) => i.value?.name),
        milestoneFragnet: source?.milestoneFragnet,
        tags: source?.tags?.filter((item) => !item.value?.isExclude).map((i) => i.value?.name),
        tagsExclude: source?.tags?.filter((item) => item.value?.isExclude).map((i) => i.value?.name),
        wbs: source?.wbs,
        minWbsLevel: source?.maxLevel[0],
        maxWbsLevel: source?.maxLevel[1],
    };
    const { pillsList: pills } = useGlobalFiltersHook({ widgetId, source: pillsData, latestVersionId });

    const highLevelProgramPayload = {
        id: [latestVersionId],
        filter: {
            filters,
        },
    };

    return {
        ui: {
            state: {
                ...state.project,
                ...state.globalFilter,
                ...state.local,
            },
            isInPinboard,
            pills,
        },
        api: {
            highLevelProgram: {
                instance: useQueryHighLevelProgram(highLevelProgramPayload),
                payload: highLevelProgramPayload,
            },
        },
    };
};
